import { Tooltip } from '@delmonicos/shared-design-system-react/src/components/tooltip/tooltip';
import { Text } from '@delmonicos/shared-design-system-react/src/components/typography/text/text';
import { GatewayTokenModel } from '@delmonicos/shared-sdk/libs/cpms/src/apps/charge-point-operators-gateway/src/tokens/models/outputs/gateway-token.model';
import { CellContext } from '@tanstack/react-table';

export interface TokenListNoteCellProps
  extends CellContext<GatewayTokenModel, GatewayTokenModel['comment']> {}

export const TokenListCommentCell = (
  props: TokenListNoteCellProps,
): React.JSX.Element => {
  // CONTEXT ///////////////////////////////////////////////////////////////////

  const { getValue } = props;

  // RENDER ////////////////////////////////////////////////////////////////////

  if (getValue()) {
    return (
      <Tooltip content={getValue()}>
        <Text>{getValue()}</Text>
      </Tooltip>
    );
  }

  return <Text>-</Text>;
};
